import { EChooseLocationDataKeys } from './types'

export const initialValues = {
  [EChooseLocationDataKeys.locationIds]: [],
}

export const chooseLocationDialogId = 'chooseLocationDialogId'

export const resetFormId = -1
